import React from 'react';

export default class CourseUserManagement extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            courseUsers: {}
        }
    }
    
    render()
    {
        return (
            <div className="lmsdisplayarea">
                <h3>Manage Course Users</h3>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/course/management/courseusermanagement.js